module.exports = "/../../dist/frontend/images/store.webp?bfdb815f70bf42d14f3a2bf77ef459b9";